import React, { Component, PropTypes } from 'react';
import Mobile from './projectComponents/Mobile.js';
import TechStackItem from './projectComponents/TechStackItem';

export default class Project extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { project } = this.props;
    const techStackItems = project.tech_stack.map((tech, index) => {
      return <TechStackItem key={index} tech={tech}/>;
    });

    return (
    <div className="main-app-container col-md-12 col-xs-12">   
       <div className="modal-project-info col-md-12 col-xs-12">

              <a href={project.project_url} target="_blank">
                <h2 className='skinny'>{project.title}</h2>
              </a>

              <a href={project.github_url} target="_blank">
                {project.github_url !== '' ? 'Github' : null}
              </a>

          <div className="modal-screenshot-container col-md-12 col-xs-12">
              <img src={project.desktop_image}/>
            
          </div> 
              <div className="col-md-12 col-xs-12 nopad">
                    <div className="col-md-6 col-xs-6 nopad">
                        <div className="col-md-4 col-xs-4 nopad">
                          <h3 className='skinny'>Type</h3>
                          <div > <span className='app-text'>{project.type}</span></div>
                        </div>
                        
                         <div className="col-md-8 col-xs-8 nopad">  
                        <h3 className='skinny'>Role</h3>
                        
                        <div ><span className='app-text'>{project.role}</span></div>
                        </div>
                    </div>

                    <div classNAme="col-md-6 col-xs-6 nopad">
                    <h3 className='skinny'>Tech Stack</h3>
                    <div className="tech-icon-container">{techStackItems}</div>
                    </div>
              </div>

              <div className="col-md-12 col-xs-12 nopad">
              <h3 className='skinny'>Background</h3>
              <div>{project.background}</div>
              </div>
          
      </div>

   

    </div>  
    );
  }
}

Project.propTypes = {
  project: PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/components/Project.js
 **/